import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    IonApp,
    IonSpinner,
    IonBackButton,
    IonBadge,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle, IonCheckbox, IonChip,
    IonCol,
    IonContent, IonDatetime, IonDatetimeButton, IonFab, IonFabButton,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonImg, IonInfiniteScroll, IonInfiniteScrollContent,
    IonInput,
    IonInputPasswordToggle,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonMenu,
    IonMenuButton,
    IonMenuToggle,
    IonModal,
    IonNote, IonPicker, IonPickerColumn, IonPickerColumnOption, IonRadio, IonRadioGroup, IonRange,
    IonRefresher,
    IonRefresherContent,
    IonRouterLink,
    IonRouterLinkWithHref,
    IonRouterOutlet,
    IonRow,
    IonSearchbar, IonSegment, IonSegmentButton, IonSelect, IonSelectOption,
    IonSkeletonText,
    IonSplitPane,
    IonText, IonTextarea, IonThumbnail,
    IonTitle,
    IonToolbar, IonTabs, IonTabBar, IonTabButton, IonAccordionGroup, IonAccordion, IonProgressBar, IonAvatar,
} from '@ionic/angular/standalone';
import { RouterLink, RouterLinkActive, RouterLinkWithHref } from '@angular/router';

const IONIC_MODULES = [
    IonRouterLink,
    IonRouterLinkWithHref,
    IonRouterOutlet,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonInput,
    IonIcon,
    IonTabs,
    IonTabBar,
    IonAccordionGroup,
    IonAccordion,
    IonTabButton,
    IonFooter,
    IonImg,
    IonItem,
    IonSpinner,
    IonLabel,
    IonButton,
    IonButtons,
    IonBackButton,
    IonList,
    IonNote,
    IonInputPasswordToggle,
    IonApp,
    IonSplitPane,
    IonMenu,
    IonListHeader,
    IonMenuToggle,
    IonMenuButton,
    IonRefresher,
    IonRefresherContent,
    IonGrid,
    IonRow,
    IonCol,
    IonText,
    IonSearchbar,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonSkeletonText,
    IonCardSubtitle,
    IonCardContent,
    IonModal,
    IonDatetime,
    IonDatetimeButton,
    IonPicker,
    IonPickerColumn,
    IonPickerColumnOption,
    IonTextarea,
    IonListHeader,
    IonBadge,
    IonSegment,
    IonProgressBar,
    IonSegmentButton,
    IonFab,
    IonFabButton,
    IonThumbnail,
    IonSelect,
    IonSelectOption,
    IonRange,
    IonRadioGroup,
    IonRadio,
    IonCheckbox,
    IonChip,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonAvatar,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterLink,
        RouterLinkWithHref,
        RouterLinkActive,
        ...IONIC_MODULES,
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterLink,
        RouterLinkWithHref,
        RouterLinkActive,
        ...IONIC_MODULES,
    ],
})
export class ThemeModule
{
}
